export default {"src":"/_next/static/media/product-slider-left-arrow.c140405d.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};